import { render } from "./GroupSharingInput.vue?vue&type=template&id=c54cab74"
import script from "./GroupSharingInput.vue?vue&type=script&lang=ts"
export * from "./GroupSharingInput.vue?vue&type=script&lang=ts"
script.render = render

export default script